'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var nameTypeSwitch = function nameTypeSwitch(profile) {
	switch (profile.type) {
		case 'specialist':
			return [profile.title, profile.firstname, profile.lastname].join(' ');
		case 'practice':
			return profile.practice_name;
		case 'patient':
			return [profile.firstname, profile.lastname].join(' ');
		default:
			return '';
	}
};

var profileTransformer = exports.profileTransformer = function profileTransformer() {
	var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return Object.assign(profile, {
		name: nameTypeSwitch(profile),
		uri_id: profile.profile_uri || profile.uri_id || profile.profile_uri_id,
		id: profile.id || profile.profile_id
	});
};

var profilesTransformer = exports.profilesTransformer = function profilesTransformer() {
	var profiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return profiles.map(profileTransformer);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/transformers/top-nav.js
// module id = 1696
// module chunks = 0